import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const LinksContainer = styled(Stack)(() => {
  return {};
});

const HeaderTypography = styled(Typography)(({ theme }) => {
  return {
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(2),
  };
});

const LinkItem = styled(Link)(({ theme }) => {
  return {
    color: theme.palette.secondary.main,
    fontSize: '12px',
    textDecoration: 'none',
    '&:visited': {
      color: theme.palette.secondary.main,
    },
    '&:hover': {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
    },
  };
});

const LinksList = ({ header, links, ...other }) => {
  return (
    <LinksContainer {...other}>
      <HeaderTypography variant="h6">{header}</HeaderTypography>
      {links.map((l, i) => {
        return (
          <LinkItem key={i} to={l.path}>
            {l.title}
          </LinkItem>
        );
      })}
    </LinksContainer>
  );
};

LinksList.propTypes = {
  header: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
};

const FooterContainer = styled('footer')(({ theme }) => {
  return {
    marginTop: theme.spacing(8),
    borderTop: `1px solid ${theme.palette.divider}`,
    background: '#F9F9F9',
  };
});

const LinksLayout = styled(Grid)(({ theme }) => {
  return {
    width: 'auto',
    margin: theme.spacing(3),
    [theme.breakpoints.up(900 + (theme.spacing(3) as any) * 2)]: {
      width: 900,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  };
});

const CopyrightContainer = styled(Grid)(() => {
  return {
    background: '#333',
    flexGrow: 1,
    height: '45px',
  };
});

const CopyrightText = styled(Typography)(() => {
  return {
    color: '#BDBDBD',
    fontSize: '12px',
  };
});

const Footer = () => {
  const menu = {
    // 'Services': [
    //   {path: '/', title: 'How It Works'},
    //   {path: '/', title: 'For Investors'},
    //   {path: '/', title: 'For Professionals'},
    //   {path: '/', title: 'Pricing'},
    //   {path: '/', title: 'How It Works'},
    // ],
    // 'Follow us': [
    //   {path: '/', title: 'LinkedIn'},
    //   {path: '/', title: 'Facebook'},
    //   {path: '/', title: 'Twitter'},
    //   {path: '/', title: 'YouTube'},
    // ],
    Company: [
      // {path: '/company/faqs', title: 'FAQs'},
      { path: '/company/about-us', title: 'About Us' },
      { path: '/company/contact-us', title: 'Contact Us' },
      { path: '/content/user-guide', title: 'User Guide' },
      // {path: '/company/media-coverage', title: 'Media Coverage'},
      // {path: '/company/media-enquiries', title: 'Media Enquiries'},
      // {path: '/company/careers', title: 'Careers'},
    ],
    Legal: [
      { path: '/company/privacy-policy', title: 'Privacy Policy' },
      { path: '/company/terms-and-conditions', title: 'Terms and Conditions' },
      // {path: '/company/complaints', title: 'Complaints'},
    ],
    'My Account': [
      { path: '/auth/login', title: 'Login' },
      { path: '/auth/signup', title: 'Sign Up' },
      { path: '/auth/forgot-password', title: 'Forgot Password' },
    ],
    Tools: [
      { path: '/calculators', title: 'Calculators' },
      { path: '/calculators/stamp-duty', title: 'Stamp Duty Calculator' },
      {
        path: '/calculators/simple-property-analysis',
        title: 'Simple Property Analysis',
      },
    ],
  };
  const items = Object.keys(menu).map((key) => {
    return (
      <Grid key={key} size="grow">
        <LinksList header={key} links={menu[key]} />
      </Grid>
    );
  });
  const year = new Date().getFullYear();
  return (
    <FooterContainer>
      <LinksLayout
        container
        spacing={4}
        justifyContent="space-evenly"
        sx={{ width: '100%' }}
      >
        {items}
      </LinksLayout>
      <CopyrightContainer
        container
        justifyContent="center"
        alignItems="center"
        sx={{ width: '100%' }}
      >
        <Grid>
          <CopyrightText>
            Copyright © {year} MyFolio App - Made by investors for investors
          </CopyrightText>
        </Grid>
      </CopyrightContainer>
    </FooterContainer>
  );
};

export default Footer;
